import { useState } from 'react';
import { Modal } from './Modal';

export function AddPartyModal({ existing, onSave, onClose }) {
  const [name,  setName]  = useState(existing?.name  || '');
  const [phone, setPhone] = useState(existing?.phone || '');
  const [type,  setType]  = useState(existing?.type  || 'customer');
  const [saving, setSaving] = useState(false);

  const submit = async () => {
    if (!name.trim()) { alert('Enter party name'); return; }
    setSaving(true);
    try { await onSave({ name: name.trim(), phone, type }); onClose(); }
    catch (e) { alert(e.message); }
    setSaving(false);
  };

  return (
    <Modal title={existing ? '✏️ Edit Party' : '➕ Add Party'} onClose={onClose}>
      <div className="form-group">
        <label className="form-label">Name *</label>
        <input className="form-input" placeholder="Customer / Supplier name"
          value={name} onChange={e => setName(e.target.value)} autoFocus />
      </div>
      <div className="form-group">
        <label className="form-label">Mobile Number</label>
        <input className="form-input" placeholder="10-digit mobile" type="tel"
          value={phone} onChange={e => setPhone(e.target.value)} />
      </div>
      <div className="form-group">
        <label className="form-label">Type</label>
        <div style={{ display: 'flex', gap: 10 }}>
          {['customer', 'supplier'].map(t => (
            <button key={t} onClick={() => setType(t)}
              style={{
                flex: 1, padding: '9px', borderRadius: 8, cursor: 'pointer',
                border: `2px solid ${type === t ? 'var(--primary)' : 'var(--border-dark)'}`,
                background: type === t ? '#e8f0fe' : 'var(--surface)',
                color: type === t ? 'var(--primary)' : 'var(--text-mid)',
                fontWeight: 600, fontSize: 13, fontFamily: 'inherit',
              }}>
              {t === 'customer' ? '🧑 Customer' : '🏪 Supplier'}
            </button>
          ))}
        </div>
      </div>
      <button className="btn btn-blue" style={{ width: '100%', justifyContent: 'center', padding: 11, fontSize: 14 }}
        onClick={submit} disabled={saving}>
        {saving ? 'Saving…' : existing ? 'Update Party' : 'Add Party'}
      </button>
    </Modal>
  );
}
